var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAngleRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_948_132)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.625 13.5C10.5806 13.4999 10.5441 13.4831 10.5225 13.4629L5.41602 8.69727L5.41602 8.69629C5.17309 8.47009 4.98199 8.20326 4.85254 7.91211C4.72325 7.62121 4.65729 7.31069 4.65723 6.99805C4.65723 6.68522 4.72316 6.37407 4.85254 6.08301C4.982 5.79183 5.17307 5.52503 5.41602 5.29883L5.41602 5.29785L10.5215 0.533203C10.5318 0.523781 10.5459 0.514528 10.5635 0.507812C10.5813 0.501029 10.602 0.497933 10.623 0.498047L10.6279 0.498047C10.649 0.497933 10.6696 0.500999 10.6875 0.507812C10.7051 0.514568 10.7192 0.52375 10.7295 0.533203L10.7295 0.53418C10.7396 0.543598 10.7456 0.552843 10.749 0.560547C10.7524 0.568212 10.7539 0.575069 10.7539 0.581055C10.7539 0.587022 10.7524 0.593937 10.749 0.601562C10.7456 0.609259 10.7396 0.618539 10.7295 0.62793L10.7275 0.629883L5.62207 5.39551L5.62109 5.39551C5.17299 5.8143 4.91406 6.39028 4.91406 6.99805C4.91419 7.60562 5.17313 8.18092 5.62109 8.59961L5.62207 8.59961L10.7275 13.3652C10.7479 13.3843 10.7529 13.4029 10.7529 13.4141C10.7529 13.4252 10.7481 13.4437 10.7275 13.4629C10.7058 13.4831 10.6694 13.5 10.625 13.5Z",
    fill: "white",
    stroke: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_948_132"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 14,
    fill: "white",
    transform: "translate(15 14) rotate(-180)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngleRight);
export default __webpack_public_path__ + "static/media/angle-right.5cbe89b67c85d7509f2745582e2a5be2.svg";
export { ForwardRef as ReactComponent };